import { useCallback } from 'react';
import { faSliders } from '@fortawesome/pro-regular-svg-icons';
import { updatePopover } from 'ducks/popovers/slices';
import { selectStrategy } from 'ducks/strategy/selectors';
import { Icon } from 'framework/Icon';
import { useStrategyApi } from 'pages/hooks/useStrategyApi';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { Card } from 'components/cards/Card';
import { ManageStrategyPopover } from 'components/popovers/strategies/ManageStrategyPopover';

import cn from './StrategySettings.module.scss';

export const StrategySettings = () => {
  const dispatch = useAppDispatch();
  const voladeum_strategy = useAppSelector(selectStrategy);
  const { getStrategyLookups } = useStrategyApi();

  const onClick = useCallback(async () => {
    await getStrategyLookups();
    dispatch(updatePopover({ key: 'strategy_manage', data: { is_open: true, is_update: true } }));
  }, [dispatch, getStrategyLookups]);

  const {
    strategy_name,
    contract_type_name,
    strike_method_name,
    expiry_method_name,
    expiry_value,
    max_position_pct_formatted,
    max_daily_loss_pct_formatted,
    max_drawdown_pct_formatted,
    slippage_tolerance_pct_formatted,
    stop_loss_offset_pct_formatted,
    take_profit_offset_pct_formatted,
    take_profit_trail_pct_formatted,
    activation_threshold_formatted,
  } = voladeum_strategy;
  return (
    <>
      <Card padding="0px" maxWidth="350px" direction="column" fit>
        <div className={cn.toolbar} onClick={onClick}>
          <p>Strategy: {strategy_name}</p>
          <Icon icon={faSliders} />
        </div>
        <div className={cn.content}>
          <div className={cn.spread}>
            <p className={cn.label}>Contract</p>
            <p className={cn.value}>{contract_type_name}</p>
            <p className={cn.label}>Strike Method</p>
            <p className={cn.value}>{strike_method_name}</p>
            <p className={cn.label}>Expiry</p>
            <p className={cn.value}>
              {expiry_value} {expiry_method_name}
            </p>
          </div>
          <p className={cn.section}>Risk</p>
          <div className={cn.spread}>
            <p className={cn.label}>Max Position</p>
            <p className={cn.value}>{max_position_pct_formatted}</p>
            <p className={cn.label}>Max Daily Loss</p>
            <p className={cn.value}>{max_daily_loss_pct_formatted}</p>
            <p className={cn.label}>Max Drawdown</p>
            <p className={cn.value}>{max_drawdown_pct_formatted}</p>
          </div>
          <p className={cn.section}>Settings</p>
          <div className={cn.spread}>
            <p className={cn.label}>Slippage Tolerance</p>
            <p className={cn.value}>{slippage_tolerance_pct_formatted}</p>
            <p className={cn.label}>Stop Loss / Take Profit</p>
            <p className={cn.value}>
              {stop_loss_offset_pct_formatted} / {take_profit_offset_pct_formatted}
            </p>
            <p className={cn.label}>Take Profit Trail</p>
            <p className={cn.value}>{take_profit_trail_pct_formatted}</p>
            <p className={cn.label}>Activation Threshold</p>
            <p className={cn.value}>{activation_threshold_formatted}</p>
          </div>
        </div>
      </Card>
      <ManageStrategyPopover />
    </>
  );
};
